import { dashboardStatsSchema } from "@redotech/redo-model/disputes/dispute-analytics";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getDisputeDashboardStats = {
  name: "getDisputeDashboardStats" as const,
  input: z.object({
    startDate: zExt.plainDate().optional(),
    endDate: zExt.plainDate().optional(),
  }),
  output: dashboardStatsSchema,
};
